/* eslint-disable import/prefer-default-export */
export const PAYMENT_ERROR_TYPE_POSTAL_CODE = 'POSTAL_CODE_ERROR'
export const PAYMENT_ERROR_TYPE_UNKNOWN = 'UNKNOWN_ERROR'
export const PAYMENT_ERROR_GIFT_PAYMENT_PENDING = 'GIFT_PAYMENT_PENDING'
